import axios from "axios";
import { API_URL } from "../../const";

/** *************** START LIST OF DIALLER PUSH LOG  DETAILS ***************** */
export const fetchDiallerPushLog = (fetchData: any) => {
  const data = {
    DiallerPushLogToken: fetchData,
  };

  const url = `${API_URL}getDiallerPushLog`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** *************** END LIST OF DIALLER PUSH LOG  DETAILS ***************** */
